// dayjs
import objectSupport from 'dayjs/plugin/objectSupport'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import relativeTime from 'dayjs/plugin/relativeTime'
import isYesterday from 'dayjs/plugin/isYesterday'
import localeData from 'dayjs/plugin/localeData'
import isBetween from 'dayjs/plugin/isBetween'
import dayOfYear from 'dayjs/plugin/dayOfYear'
import isToday from 'dayjs/plugin/isToday'
import tz from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import dayjs from 'dayjs'

// primereact
import { addLocale } from 'primereact/api'

// utils
import { esLocale } from '@centria-ui/commons/i18n'

dayjs.extend(objectSupport)
dayjs.extend(isSameOrAfter)
dayjs.extend(relativeTime)
dayjs.extend(isYesterday)
dayjs.extend(localeData)
dayjs.extend(dayOfYear)
dayjs.extend(isBetween)
dayjs.extend(isToday)
dayjs.extend(utc)
dayjs.extend(tz)

addLocale('es', esLocale)
